import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'

import { createQueryClient } from '@/lib/api/query'
import { router } from '@/routes/router'

import '@/styles/index.css'

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('#root 엘리먼트를 찾지 못했습니다. index.html 을 확인해 주세요.')
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={createQueryClient()}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>
)
